/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Insider } from '../models/insider';
import { InsiderRelationshipMappingFilter } from '../models/insider-relationship-mapping-filter';
import { InsiderRelationshipMap } from '../models/insider-relationship-map';
import { ParentWithMultipleChildren } from '../models/parent-with-multiple-children';
import { InsiderRelationshipToMap } from '../models/insider-relationship-to-map';
@Injectable({
  providedIn: 'root',
})
class InsiderRelationshipMappingService extends __BaseService {
  static readonly getParentInsiderPath = '/insiderRelationshipMapping/parent-insider';
  static readonly getChildInsiderPath = '/insiderRelationshipMapping/child-insider';
  static readonly getProcessedRelationshipsPath = '/insiderRelationshipMapping/processed';
  static readonly getMultipleChildrenRelationshipsPath = '/insiderRelationshipMapping/multiple-children';
  static readonly mapInsiderRelationshipPath = '/mapInsiderRelationship/map';
  static readonly updateInsiderRelationshipPath = '/mapInsiderRelationship/update';
  static readonly removeRelationPath = '/mapInsiderRelationship/removeRelation';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param mappingFilter undefined
   * @return it will be return list of insiders.
   */
  getParentInsiderResponse(mappingFilter: InsiderRelationshipMappingFilter): __Observable<__StrictHttpResponse<Array<Insider>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappingFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/insiderRelationshipMapping/parent-insider`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Insider>>;
      })
    );
  }
  /**
   * @param mappingFilter undefined
   * @return it will be return list of insiders.
   */
  getParentInsider(mappingFilter: InsiderRelationshipMappingFilter): __Observable<Array<Insider>> {
    return this.getParentInsiderResponse(mappingFilter).pipe(
      __map(_r => _r.body as Array<Insider>)
    );
  }

  /**
   * @param mappingFilter undefined
   * @return it will be return list of insiders.
   */
  getChildInsiderResponse(mappingFilter: InsiderRelationshipMappingFilter): __Observable<__StrictHttpResponse<Array<Insider>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappingFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/insiderRelationshipMapping/child-insider`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Insider>>;
      })
    );
  }
  /**
   * @param mappingFilter undefined
   * @return it will be return list of insiders.
   */
  getChildInsider(mappingFilter: InsiderRelationshipMappingFilter): __Observable<Array<Insider>> {
    return this.getChildInsiderResponse(mappingFilter).pipe(
      __map(_r => _r.body as Array<Insider>)
    );
  }

  /**
   * @param mappingFilter undefined
   * @return it will be return list of Insider Relationship map.
   */
  getProcessedRelationshipsResponse(mappingFilter: InsiderRelationshipMappingFilter): __Observable<__StrictHttpResponse<Array<InsiderRelationshipMap>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappingFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/insiderRelationshipMapping/processed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InsiderRelationshipMap>>;
      })
    );
  }
  /**
   * @param mappingFilter undefined
   * @return it will be return list of Insider Relationship map.
   */
  getProcessedRelationships(mappingFilter: InsiderRelationshipMappingFilter): __Observable<Array<InsiderRelationshipMap>> {
    return this.getProcessedRelationshipsResponse(mappingFilter).pipe(
      __map(_r => _r.body as Array<InsiderRelationshipMap>)
    );
  }

  /**
   * @param mappingFilter undefined
   * @return Returns list of parent insiders with multiple children (child count > 1)
   */
  getMultipleChildrenRelationshipsResponse(mappingFilter: InsiderRelationshipMappingFilter): __Observable<__StrictHttpResponse<Array<ParentWithMultipleChildren>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappingFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/insiderRelationshipMapping/multiple-children`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ParentWithMultipleChildren>>;
      })
    );
  }
  /**
   * @param mappingFilter undefined
   * @return Returns list of parent insiders with multiple children (child count > 1)
   */
  getMultipleChildrenRelationships(mappingFilter: InsiderRelationshipMappingFilter): __Observable<Array<ParentWithMultipleChildren>> {
    return this.getMultipleChildrenRelationshipsResponse(mappingFilter).pipe(
      __map(_r => _r.body as Array<ParentWithMultipleChildren>)
    );
  }

  /**
   * @param insiderRelationshipToMap undefined
   * @return it will be return boolean that whether insider was connected or not.
   */
  mapInsiderRelationshipResponse(insiderRelationshipToMap: InsiderRelationshipToMap): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = insiderRelationshipToMap;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/mapInsiderRelationship/map`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param insiderRelationshipToMap undefined
   * @return it will be return boolean that whether insider was connected or not.
   */
  mapInsiderRelationship(insiderRelationshipToMap: InsiderRelationshipToMap): __Observable<boolean> {
    return this.mapInsiderRelationshipResponse(insiderRelationshipToMap).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param insiderRelationshipMap undefined
   * @return it will be return boolean that whether insider was updated or not.
   */
  updateInsiderRelationshipResponse(insiderRelationshipMap: InsiderRelationshipMap): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = insiderRelationshipMap;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/mapInsiderRelationship/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param insiderRelationshipMap undefined
   * @return it will be return boolean that whether insider was updated or not.
   */
  updateInsiderRelationship(insiderRelationshipMap: InsiderRelationshipMap): __Observable<boolean> {
    return this.updateInsiderRelationshipResponse(insiderRelationshipMap).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param relationId undefined
   * @return it will return a boolean that whether relation was deleted or not.
   */
  removeRelationResponse(relationId: number): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (relationId != null) __params = __params.set('relationId', relationId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/mapInsiderRelationship/removeRelation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param relationId undefined
   * @return it will return a boolean that whether relation was deleted or not.
   */
  removeRelation(relationId: number): __Observable<boolean> {
    return this.removeRelationResponse(relationId).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module InsiderRelationshipMappingService {
}

export { InsiderRelationshipMappingService }
